let scene_settings = {
    "background": {"color": [0,0,0,1]},
    "camera": {
        "fov": 70.0,
        "position": [0, 0, 1],
        "target": [0, 0, 0],
        "startAnim": "orbit",
        "up": [0,1,0]
    }
};

const url = new URL(location.href);

// const settingsUrl = url.searchParams.get('settings') || './settings.json';
const settingsUrl = url.searchParams.get('settings');

if (settingsUrl) {
    fetch(settingsUrl)
        .then(response => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.json();
        })
        .then(data => {
            if (data.animTracks && data.animTracks.length > 0) {
                scene_settings.animTracks = data.animTracks;
            }
        })
        .catch(() => {
        });
}

// const contentUrl = url.searchParams.has('content') ? url.searchParams.get('content') : './scene.compressed.ply';
// const contentUrl = url.searchParams.has('url') ? url.searchParams.get('url') : './scene.compressed.ply';
// const modelURLParam = url.searchParams.get("url");

// 1. Fallback
// const DEFAULT_SCENE_URL = './scene.compressed.ply';
const FILE_PRIORITY_LIST = [
    'splat_cropped.sog',
    'splat.sog',
    'splat_cropped.ply',
    'splat.ply'
];

/**
 * @param {string} baseUrl
 * @param {string[]} filenames
 * @returns {Promise<string|null>}
 */
async function findFirstAvailableFile(baseUrl, filenames) {
    for (const filename of filenames) {
        const fullUrl = baseUrl + filename;
        try {
            const response = await fetch(fullUrl, { method: 'HEAD' });

            if (response.ok) {

                return fullUrl;
            } else {

            }
        } catch (error) {

        }
    }

    return null;
}

const DEFAULT_SCENE_URL = './scene.compressed.ply';

async function findInitView_scene(finalUrl, scene_settings) {

    const jsonUrl = finalUrl.replace(/[^/]+$/, 'init_view.json');

    // 1. Get current URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Check for the existence of specific parameters
    const hasCP = urlParams.has('cp');   // Has camera position?
    const hasCU = urlParams.has('cu');   // Has camera up?
    const hasCLA = urlParams.has('cla'); // Has camera look at?

    if (jsonUrl) {
        fetch(jsonUrl)
            .then(response => {
                if (!response.ok) throw new Error(`HTTP ${response.status}`);
                return response.json();
            })
            .then(data => {
                // 2. Conditional Logic: Only apply JSON values if URL parameters are NOT present.
                // This prevents overwriting manual URL overrides.

                // If 'cp' is not in URL, load 'cp' from JSON
                if (!hasCP) {
                    scene_settings.camera.position[0] = -data.cp[0];
                    scene_settings.camera.position[1] = -data.cp[1];
                    scene_settings.camera.position[2] = data.cp[2];
                } else {

                }

                // If 'cu' is not in URL, load 'cu' from JSON
                if (!hasCU) {
                    scene_settings.camera.up[0] = -data.cu[0];
                    scene_settings.camera.up[1] = -data.cu[1];
                    scene_settings.camera.up[2] = data.cu[2];
                }

                // If 'cla' is not in URL, load 'cla' from JSON
                if (!hasCLA) {
                    scene_settings.camera.target[0] = -data.cla[0];
                    scene_settings.camera.target[1] = -data.cla[1];
                    scene_settings.camera.target[2] = data.cla[2];
                }

            })
            .catch(() => {
                // Error handling
            });
    }
    else{

    }
}

async function findInitView_object(finalUrl, scene_settings) {


    const bboxUrl = finalUrl.replace(/[^/]+$/, 'scene_bbox.json');

    // URL params
    const urlParams = new URLSearchParams(window.location.search);
    const hasCP = urlParams.has('cp');
    const hasCU = urlParams.has('cu');
    const hasCLA = urlParams.has('cla');

    try {
        const res = await fetch(bboxUrl);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const data = await res.json();

        const center = data.focus_center_pos; // [x, y, z]
        const size = data.focus_size; // [sx, sy, sz]

        const maxSize = Math.max(size[0], size[1], size[2]);
        const distanceScale = 2.5;
        const distance = maxSize * distanceScale;

        if (!hasCLA) {
            scene_settings.camera.target[0] = -center[0];
            scene_settings.camera.target[1] = -center[1];
            scene_settings.camera.target[2] =  center[2];
        } else {

        }

        if (!hasCP) {
            scene_settings.camera.position[0] = -center[0];
            scene_settings.camera.position[1] = -center[1];
            scene_settings.camera.position[2] =  center[2] - distance;
        } else {

        }

        if (!hasCU) {
            scene_settings.camera.up[0] = 0;
            scene_settings.camera.up[1] = 1;
            scene_settings.camera.up[2] = 0;
        } else {

        }

    } catch (err) {

    }
}

async function initializeModel() {
    let baseUrl = '';
    let finalContentUrl = null;

    try {
        const hostname = window.location.hostname;
        const isStaging = hostname === 'venreal3d-staging.venraas.tw' || hostname === 'localhost';
        const BUCKET_STAGING = 'macaron_melody-staging';
        const BUCKET_PRODUCTION = 'macaron_melody';
        const defaultBucket = isStaging ? BUCKET_STAGING : BUCKET_PRODUCTION;

        const url = new URL(window.location.href);
        const idParam = url.searchParams.get('id');
        let urlParam = url.searchParams.get('url');

        if (idParam) {
            const decodedPath = atob(idParam).trim();
            baseUrl = `https://storage.googleapis.com/${defaultBucket}/${decodedPath}/model/web/`;
        } else if (urlParam) {
            // Check if the urlParam is a direct link to a model file
            if (urlParam.endsWith('.ply') || urlParam.endsWith('.sog') || urlParam.endsWith('.json')) {

                try {
                    // Verify the direct path with a HEAD request for robustness
                    const response = await fetch(urlParam, { method: 'HEAD' });
                    if (response.ok) {
                        // If the file exists, set it as the final URL
                        urlParam = decodeURIComponent(urlParam);
                        finalContentUrl = urlParam;
                    } else {

                    }
                } catch (e) {

                }
            } else {
                // If not a file path, treat it as a directory (original logic)
                baseUrl = urlParam.endsWith('/') ? urlParam : urlParam + '/';
            }
        }

    } catch (e) {

    }

    // Probe for a file only if a final URL has not been determined yet and a baseUrl exists.
    if (!finalContentUrl && baseUrl) {
        finalContentUrl = await findFirstAvailableFile(baseUrl, FILE_PRIORITY_LIST);
    }

    // cropped case (i.e., object)
    if (finalContentUrl.endsWith('splat_cropped.sog') || finalContentUrl.endsWith('splat_cropped.ply')){
        await findInitView_object(finalContentUrl, scene_settings);
    }
    // non-cropped case (i.e., scene)
    else{
        await findInitView_scene(finalContentUrl, scene_settings);
    }

    // Fallback logic remains unchanged.
    if (!finalContentUrl) {

        finalContentUrl = DEFAULT_SCENE_URL;
    }

    return finalContentUrl;
}

const params = {};

const alphaParam = url.searchParams.get("alpha");
const modelParam = url.searchParams.get("model");
const shParam = url.searchParams.get("sh");
const svoParam = url.searchParams.get("svo");
const cameraUpParam = url.searchParams.get("cu");
const cameraPositionParam = url.searchParams.get("cp");
const cameraLookAtParam = url.searchParams.get("cla");
const ZoomInFactorParam = url.searchParams.get("zi");
const ZoomOutFactorParam = url.searchParams.get("zo");
const antialiasedParam = url.searchParams.get("aa");
const bgColorParam = url.searchParams.get("bg");
const lineColorParam = url.searchParams.get("lbg");

// --- Pitch range parameters from URL ---
const pitchMinParam = url.searchParams.get("pitchMin");
const pitchMaxParam = url.searchParams.get("pitchMax");

if (pitchMinParam !== null) {
    params.pitchMin = parseFloat(pitchMinParam);
}
if (pitchMaxParam !== null) {
    params.pitchMax = parseFloat(pitchMaxParam);
}
// --- Yaw range parameters from URL ---
const yawMinParam = url.searchParams.get("yawMin");
const yawMaxParam = url.searchParams.get("yawMax");

if (yawMinParam !== null) {
    params.yawMin = parseFloat(yawMinParam);
}
if (yawMaxParam !== null) {
    params.yawMax = parseFloat(yawMaxParam);
}

// --- allowPan from URL ---
const enablepan = url.searchParams.get('enablepan');
params.enablepan = enablepan !== null ? parseFloat(enablepan) : 1;

if (cameraPositionParam !== null) {
    var cameraPositionXYZ = cameraPositionParam.split(',');
    for (let i = 0; i < 2; i++) {
        cameraPositionXYZ[i] = -1 * parseFloat(cameraPositionXYZ[i]);
    }
    cameraPositionXYZ[2] = parseFloat(cameraPositionXYZ[2]);
    scene_settings.camera.position = cameraPositionXYZ;
    params.initialCameraPosition = cameraPositionXYZ;
    // viewerOptions['initialCameraPosition'] = cameraPositionXYZ;
};
if (cameraUpParam !== null) {
    var cameraUpXYZ = cameraUpParam.split(',');
    for (let i = 0; i < 2; i++) {
        cameraUpXYZ[i] = -1 * parseFloat(cameraUpXYZ[i]);
    }
    cameraUpXYZ[2] = parseFloat(cameraUpXYZ[2]);
    scene_settings.camera.up = cameraUpXYZ;
    params.cameraUp = cameraUpXYZ;
    // viewerOptions['cameraUp'] = cameraUpXYZ;
};
if (cameraLookAtParam !== null) {
    var cameraLookAtXYZ = cameraLookAtParam.split(',');
    for (let i = 0; i < 2; i++) {
        cameraLookAtXYZ[i] = -1 * parseFloat(cameraLookAtXYZ[i]);
    }
    cameraLookAtXYZ[2] = parseFloat(cameraLookAtXYZ[2]);
    scene_settings.camera.target = cameraLookAtXYZ;
    params.initialCameraLookAt = cameraLookAtXYZ;
    // viewerOptions['initialCameraLookAt'] = cameraLookAtXYZ;
};

if (ZoomInFactorParam !== null) {
    params.ZoomInFactor = parseFloat(ZoomInFactorParam);
    // viewerOptions['zoomInFactor'] = parseFloat(ZoomInFactorParam);
};

if (ZoomOutFactorParam !== null) {
    params.ZoomOutFactor = 2 * parseFloat(ZoomOutFactorParam);
    // viewerOptions['zoomOutFactor'] = parseFloat(ZoomOutFactorParam);
};

if (svoParam !== null) {
    params.initSceneViewOption = parseInt(svoParam);
} else {
    params.initSceneViewOption = 1;
};

if (bgColorParam !== null) {
    if (bgColorParam == 1) {
        scene_settings.background.color = [0,0,0,0];
    }
}

// apply url parameter overrides
// if (url.searchParams.has('noui')) params.noui = true;
const nouiParam = url.searchParams.get('noui');
params.noui = (nouiParam !== null && nouiParam !== '') ? Number(nouiParam) : 1;

if (url.searchParams.has('noanim')) params.noanim = true;
if (url.searchParams.has('poster')) params.posterUrl = url.searchParams.get('poster');
if (url.searchParams.has('skybox')) params.skyboxUrl = url.searchParams.get('skybox');
if (url.searchParams.has('ministats')) params.ministats = true;

const createImage = (url) => {
    const img = new Image();
    img.src = url;
    return img;
};

if (settingsUrl) {
    fetch(settingsUrl)
        .then(response => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.json();
        })
        .then(data => {
            if (data.focus_center_pos) inputdata(data);
        })
        .catch(error => {
        });
}

function inputdata(data){
    scene_settings.camera.position[0] = 2.5 * data.focus_size[0];
    scene_settings.camera.position[1] = 1.0 * data.focus_size[1];
    scene_settings.camera.position[2] = 2.5 * data.focus_size[2];
    scene_settings.camera.target[1] = Math.abs(0.5 * data.focus_size[1]);
}

const contentUrl = await initializeModel();



window.sse = {
    poster: params.posterUrl && createImage(params.posterUrl),
    settings: scene_settings,
    contentUrl,
    contents: contentUrl,
    params
};

// Load the poster image if available
const poster = window.sse?.poster;
if (poster) {
    const element = document.getElementById('poster');
    element.style.backgroundImage = `url(${poster.src})`;
    element.style.display = 'block';
    element.style.filter = 'blur(40px)';
}

// Keep pointer interactions inside the viewer controls.
for (const id of ['buttonContainer', 'infoPanelContent']) {
    document.getElementById(id)?.addEventListener('pointerdown', event => event.stopPropagation());
}
